import React from 'react';
import PropTypes from 'prop-types';

import Collapsible from 'react-collapsible';
import CollapsibleItem from '../CollapsibleItem';

import { Container, CollapsibleWraper } from './EditableSubSection.styles';

class EditableSubSection extends React.Component {
  static propTypes = {
    collapsed: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    children: PropTypes.node,
    icon: PropTypes.node,
    nested: PropTypes.bool,
    open: PropTypes.bool,

    headerBg: PropTypes.string,
    bodyBg: PropTypes.string,

    headerFontSize: PropTypes.string,
    headerPaddingY: PropTypes.string,
    headerPaddingX: PropTypes.string
  };

  static defaultProps = {
    children: null,
    nested: false,
    icon: null,
    subsection: false,
    open: true,

    headerBg: '#101b2e',
    bodyBg: '#ffffff',

    headerFontSize: '11px',
    headerPaddingY: '4px',
    headerPaddingX: '10px'
  };

  state = {
    opened: this.props.open
  };

  toggleOpen = () => {
    this.setState((prevState) => ({ opened: !prevState.opened }));
  };

  getScopeClass = () => {
    const slug = String(this.props.title || 'section')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');
    return `editable-subsection-${slug}`;
  };

  renderTrigger = () => (
    <Container overflow={this.props.nested ? 18 : 0}>
      <CollapsibleItem
        collapsed={this.props.collapsed}
        openable={!!this.props.children}
        icon={this.props.icon}
        pointer={!!this.props.children}
        opened={this.state.opened}
        nested={this.props.nested}
        subsection={this.props.subsection}
      >
        {this.props.title}
      </CollapsibleItem>
    </Container>
  );

  render() {
    const scopeClass = this.getScopeClass();

    return (
      <CollapsibleWraper className={scopeClass}>
        <style>
          {`
    /* 100% szerokości tylko na wrapperach, NIE na dzieciach */
    .${scopeClass},
    .${scopeClass} .Collapsible,
    .${scopeClass} .Collapsible__trigger,
    .${scopeClass} .Collapsible__contentOuter,
    .${scopeClass} .Collapsible__contentInner {
      width: 100% !important;
      box-sizing: border-box !important;
    }

    /* Trigger: flex, mniejszy font, mniejsza wysokość (BEZ tła) */
    .${scopeClass} .Collapsible__trigger {
      /* background-color: ${this.props.headerBg} !important; */

      padding: ${this.props.headerPaddingY} ${this.props.headerPaddingX} !important;
      font-size: ${this.props.headerFontSize} !important;
      line-height: 1.05 !important;

      display: flex !important;
      align-items: center !important;
      justify-content: space-between !important;
    }

    /* Zmniejsz font wewnątrz, ale NIE ruszaj width i NIE dawaj tła */
    .${scopeClass} .Collapsible__trigger * {
      font-size: ${this.props.headerFontSize} !important;
      line-height: 1.05 !important;
    }

    /* Strzałka ma zostać normalnej szerokości */
    .${scopeClass} .Collapsible__trigger .Collapsible__trigger__arrow,
    .${scopeClass} .Collapsible__trigger__arrow {
      width: auto !important;
      flex: 0 0 auto !important;
      margin-left: 8px !important;
    }

    /* Tytuł bierze wolne miejsce */
    .${scopeClass} .Collapsible__trigger > :first-child {
      flex: 1 1 auto !important;
      min-width: 0 !important;
    }

    /* Content tło (to zostaje) */
    .${scopeClass} .Collapsible__contentOuter,
    .${scopeClass} .Collapsible__contentInner {
      background-color: ${this.props.bodyBg} !important;
    }
  `}
        </style>

        <Collapsible
          trigger={this.renderTrigger()}
          transitionTime={150}
          onOpening={this.toggleOpen}
          onClosing={this.toggleOpen}
          open={this.props.open}
        >
          {!this.props.collapsed ? (
            <Container overflow={this.props.nested ? 28 : 0}>
              {this.props.children}
            </Container>
          ) : null}
        </Collapsible>
      </CollapsibleWraper>
    );
  }
}

export default EditableSubSection;
